'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService, $http) {
    let model = this;
    $scope.global = Global;
    model.settings = settings;

    model.tableIdentifiers = { key: false, id: false };

    model.formFields = {
        zone: "N/A",
        ioc_type: '',
        radio: '',
    }

    if ($stateParams.include) {
        model.formFields.ioc_rule = $stateParams.include[0].value;
    }

    model.radio = 0;

    // inital setup of form variable
    model.setForm = function (form) {
        model.formFields = model.formFields;
    }

    model.handleInsert = function (data) {
        let time = angular.copy($scope.main.getTime());
        data.email = $scope.global.user.email;
        data.time = Math.round(new Date().getTime() / 1000);
        if (typeof $scope.main.dataObjects[model.tableIdentifiers.key].settings.render !== "undefined") {
            $scope.main.dataObjects[model.tableIdentifiers.key].settings.render.has = false;
        }
        $http({
            method: 'POST',
            url: api+'/api/ioc_notifications/whitelist/insert',
            data : {
                id : data.id,
                email : data.email,
                ioc_rule : data.ioc_rule,
                ioc_type : data.ioc_type,
                time : data.time,
                zone : data.zone
            }
        }).success(function (result) {
            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                $scope.main.buildDimGroup(result, model.tableIdentifiers).then(function () {
                    // initalize rows
                    $scope.$broadcast('init', model.tableIdentifiers);
                })
            }
            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filter(function (d) {
                return (d.id == result[0].id);
            });
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.remove();
            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filterAll();
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result);
            $scope.$broadcast('updatedData', model.tableIdentifiers.id);
        })
        model.formFields = {
            zone: "N/A",
            ioc_type: '',
            radio: '',
        }
        delete model.editMode;
        model.customIOCForm.$setPristine();
        model.setForm();
    }

    // DELETE ROW FROM TABLE
    model.deleteTarget = function (data) {
        if (typeof $scope.main.dataObjects[model.tableIdentifiers.key].settings.render !== "undefined") {
            $scope.main.dataObjects[model.tableIdentifiers.key].settings.render.has = false;
        }
        $http({
            method: 'POST',
            url: api+'/api/ioc_notifications/whitelist/delete',
            data: {
                id : data.id,
            }
        }).success(function () {
            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filter(function (d) {
                return (d.id == data.id);
            });
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.remove();
            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filterAll();
            $scope.$broadcast('updatedData', model.tableIdentifiers.id);
        })
    }

    model.editTarget = function (call, data) {
        model.formFields = data;
        model.editMode = {
            call: call,
            id: data.id,
            value: true
        };
        model.isSelected();
    }

    model.isSelected = function (val) {
        if (val) {
            model.formFields.radio = val;
            if (model.formFields.ioc_rule) {
                model.formFields.ioc_rule = model.formFields.ioc_rule.replace(/([*])/g,"")
                if (val === "before") {
                    model.formFields.ioc_rule = "*"+model.formFields.ioc_rule
                } else if (val === "after") {
                    model.formFields.ioc_rule = model.formFields.ioc_rule+"*"
                } else {
                    model.formFields.ioc_rule = "*"+model.formFields.ioc_rule+"*"
                }
            } else {
                model.formFields.radio = "";
            }
        } else {
            if (model.formFields.ioc_rule) {
                if (model.formFields.ioc_rule.indexOf("*") > -1) {
                    if (model.formFields.ioc_rule) {
                        if ((model.formFields.ioc_rule.startsWith('*')) && (model.formFields.ioc_rule.length > 1) && (model.formFields.ioc_rule.endsWith('*'))) {
                            model.formFields.radio = "contains";
                        } else if (model.formFields.ioc_rule.startsWith('*')) {
                            model.formFields.radio = "before";
                        } else if (model.formFields.ioc_rule.endsWith('*')) {
                            model.formFields.radio = "after";
                        }
                    }
                    model.formFields.ioc_rule = model.formFields.ioc_rule.replace(/([*])/g,"")
                    if (model.formFields.radio === "before") {
                        model.formFields.ioc_rule = "*"+model.formFields.ioc_rule
                    } else if (model.formFields.radio === "after") {
                        model.formFields.ioc_rule = model.formFields.ioc_rule+"*"
                    } else if (model.formFields.radio === "contains") {
                        model.formFields.ioc_rule = "*"+model.formFields.ioc_rule+"*"
                    }
                } else {
                    model.formFields.radio = "";
                }
            }
        }
    }

    socketIo('/api/ioc_notifications/whitelist').then(function (socket) {
        /////////////
        /// TABLE ///
        /////////////
        // register data object
        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: false, // TODO: if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'table',
                socket: socket
            },
            grouping: ['id'],
            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
            hideToggleBytes: true,
            title: 'Indicators of Compromise (IOC) Notifications',
            columns: [
                { title: 'Created', select: 'time', dView: true },
                { title: 'Created By', select: 'email', dView: true },
                { title: 'IOC Type', select: 'ioc_type', dView: true },
                { title: 'IOC Rule', select: 'ioc_rule', dView: true },
                {
                    title: 'Delete',
                    select: "Delete",
                    dView: true,
                    link: {
                        type: 'Delete',
                        call: 'delete',
                    },
                },
                {
                    title: 'Edit',
                    select: 'Edit',
                    dView: true,
                    link: {
                        type: 'Edit',
                        call: 'insert',
                    },
                }
            ],
            searchCategories: {
                'email': 'Email',
                'ioc_type': 'IOC Type',
                'ioc_rule': 'IOC Rule',
            }
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.tableIdentifiers = {
                id: result.id,
                key: result.key
            }
            // initalize table with column information so it can compile the directive
            $scope.$broadcast('table-build', model.tableIdentifiers);
            let time = angular.copy($scope.main.getTime());
            model.loadStart = time.end
            model.loadEnd = time.end
            // return promise to build dimensions and groups for table
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {
            model.complete = true;
            // stop the table spinner as soon as the resolve comes in
            usSpinnerService.stop(model.tableIdentifiers.id);
        }, function (err) {

        }, function (result) {
            // add rows
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                // with our first data return, we can build dimensions and groups for our data
                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
                    // dont start the spinner if the table loads faster than building group dim
                    if (!model.complete) {
                        // start table spinner right before init, but after build
                        usSpinnerService.spin(model.tableIdentifiers.id);
                    }
                    // initalize rows
                    $scope.$broadcast('init', model.tableIdentifiers);
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                }, function (err) {
                    console.log('error')
                    console.log(err)
                })
            } else {
                if (result.min) {
                    model.loadStart = result.min;
                }
                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
            }
        })
        $scope.$on('$destroy', function () {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService', '$http'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/ioc_notifications/whitelist.js
 **/